module.exports = __webpack_public_path__ + "img/TPV-L1-6-Pagina6 D.50092b6c.png";